var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigFiveFacets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.88 59.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #6533e9;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1.5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.49,50.12h9.61c1.27,0,2.3-1.02,2.3-2.28v-7.3l4.5-.92c1.01-.22,1.54-1.37,1.01-2.28l-4.38-7.7c-.2-.34-.27-.74-.22-1.14.09-.79.14-1.6.14-2.41,0-1.68-.2-3.31-.59-4.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.34,21.22c-.39,1.56-.59,3.2-.59,4.88,0,6.25,2.77,11.88,7.18,15.78v16.87h23.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.8,46.04l1.57,1.55c1.62,1.62,3.83,2.53,6.13,2.53"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "33.37 50.13 33.37 58.75 30.42 58.75"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.51,21.22v-4.59h.07s4.62-.65,4.62-.65c.33-1.35.87-2.62,1.57-3.81l-2.86-3.76,4.28-4.26,3.76,2.84c1.17-.69,2.46-1.23,3.81-1.57l.64-4.67h6.05l.65,4.67c1.35.34,2.62.88,3.81,1.57l3.76-2.84,4.26,4.26-2.84,3.76c.7,1.18,1.23,2.46,1.57,3.81l4.68.65v4.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.85,21.22c.11-.5.17-1.02.17-1.56,0-4.19-3.4-7.58-7.59-7.58s-7.58,3.4-7.58,7.58c0,.54.06,1.06.17,1.56"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 43.87,
    y1: 21.22,
    x2: 1.34,
    y2: 21.22
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigFiveFacets);
export default __webpack_public_path__ + "static/media/big-five-facets.92b6627b356dbf03481241f610dc9c6a.svg";
export { ForwardRef as ReactComponent };